import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate, Navigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import COLORS  from '../../colors'
import './index.css'
import Header from '../Header'
import ModalStornAlert from '../ModalStornAlert'
import Confirmation from '../ConfirmationComponent'
import Loading from '../LoadingComponent'
import moment from 'moment'
import axios from 'axios'
import { useSwipeable } from 'react-swipeable'
import { getHostName, getHostNameTPS } from '../../base.js'
import { Button, Divider, Table, TableHead, TableBody, TableRow, TableCell, useMediaQuery, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'

const useStyles = makeStyles((theme) => ({
	searchInput:{
		width: '100%'
	},
	input: {
		background: '#F2F2F2',
		borderRadius: '2rem',
		margin: '1rem'
	},
	table: {
		  width:'100%',       
	},
	nameHead: {
		paddingTop:'0.6rem',
		paddingBottom:'0.6rem',
		padingRight: 0,
		paddingLeft:'1rem',
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
	},
	priceHead: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
	},
	quantityHead: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
	},
	nameBody: {
		padding:0,
		paddingTop:'0.6rem',
		paddingBottom:'0.6rem',
		paddingLeft:'1rem',
		color: COLORS.blue,
		fontWeight: '700',
		maxWidth:'45vw',
	},
	priceBody:{
		padding:0,
		color: COLORS.green,
		fontWeight: '700', 
	},
	quantityBody: {
		padding:0,
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
	}
	 
}));

const DetailsList = ({ cid, token, item, transactionList, prevPage }) => {
		const matches = useMediaQuery('(min-width:600px)')
  		const [ popup, setPopup ] = useState(false)
		const [ isConfirm, setIsConfirm ] = useState(false)
		const [ isLoading, setIsLoading ] = useState(false)
		const [ isReject, setIsReject ] = useState(false)
		const { partialStorne, setPageNumber, setTransactionList, signOut } = useContext(AuthContext)
		const [ articles, setArticles ] = useState(null)
		const params = useParams()
		const navigate = useNavigate()
		const classes = useStyles()
		const currDate = new Date()
		useEffect(()=>{

			if(item.ARTICLES!==undefined&&item.REFUND_ARTICLES!==undefined){

				if(item.ARTICLES==="[]"){
						setArticles(JSON.parse(item.REFUND_ARTICLES))			 
				}else if(item.REFUND_ARTICLES==="[]"){
						setArticles(JSON.parse(item.ARTICLES))	 
				}else{
						var strArticles = item.ARTICLES.substring(0,item.ARTICLES.length-1)   
						var strRefundArticles = item.REFUND_ARTICLES.substring(1, item.REFUND_ARTICLES.length)
						 
						setArticles(JSON.parse(strArticles + ','  + strRefundArticles))
				}				 

			}else if(item.REFUND_ARTICLES===undefined&&item.ARTICLES!==undefined){

						if(item.ARTICLES!=="[]"){
								setArticles(JSON.parse(item.ARTICLES))
						}

			} 
		},[])
	 	
		// setup ref for your usage
		const myRef = useRef();
		const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

		const handleLeftSwipe = () => {
			setPageNumber(prevPage)
				if(prevPage===3){
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/povijest-transakcija`)
					},0)
				}else{
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/izvjestaji`)
					},0)
				}	
		}

		const handleRightSwipe = () => 
		{
			if(item.amount!==item.amountVoided)
			{
					setPageNumber(10)
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/djelomicno-storno/${params.keks_id}`)
					},0)

			}
		}
	
		const refPassthrough = (el) => {
				// call useSwipeable ref prop with el
				handlers.ref(el)
				// set myRef el so you can access it yourself
				myRef.current = el
		}

		const fullStorne = async () => {

			const requestBody = { tid:params.tid, token:token, keks_id:item.keksId, amount:item.amount, articles:articles, epochtime: Math.floor(Date.now() / 1000) }
			console.log(requestBody)
            return await axios.post(getHostNameTPS() + '/v2/refund',
							requestBody).then(response => {
                                    return response.data
            }).catch(error => {
                                    console.log("Error happend while requesting the data...")
									signOut(cid)
            })
        }

  		const handleFullAmountStorne = () => {
			setPopup(false)
			setIsLoading(true)
			fullStorne().then(apiData=>{
					setIsLoading(false)
					if(apiData.resultCode===0){
						setIsConfirm(true)
						var arr = []
						for(var num in transactionList){
								if(transactionList[num].keksId!==item.keksId){
										arr=[...arr, transactionList[num]]
								}else{
										var tempItem = item
										tempItem.amountVoided = parseFloat(parseFloat(item.amount).toFixed(2))
										arr=[...arr, tempItem]
								}
						}
						setTransactionList(arr)
					}else if(apiData.resultCode===333){
						signOut(cid)
					}else{
						setPopup(true)
						setIsReject(true)
					}
			})
  		}

		const handleClose = () => {
			setPopup(false)
			setIsReject(false)
		}
		
		useEffect(() => {
			window.addEventListener('popstate', onBackButtonEvent)
			 
			return () => {
					window.removeEventListener('popstate', onBackButtonEvent);
			}
	  	}, [])
  		const onBackButtonEvent = (e) => {
				e.preventDefault()
				setPageNumber(prevPage)
				if(prevPage===3){
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/povijest-transakcija`)
					},0)
				}else{
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/izvjestaji`)
					},0)
				}	 	 
  		}

		useEffect(() => 
		{   
			const handleReload = async (e) => 
			{
				e.preventDefault()
				signOut(cid)
				setTimeout(() => window.location.assign(`/kekspos`, 0));
				window.removeEventListener('beforeunload', handleReload) 		
				return false
			}
	  
			window.addEventListener("beforeunload", handleReload)
			   
			return () => 
			{    
				window.removeEventListener('beforeunload', handleReload) 
			}
		
		}, [])

	if(!isConfirm&&!isLoading){
	return (
    	<div className="details">
			<ModalStornAlert popup={popup} 
							item={item} 
							pageNumber={4}
							isReject={isReject} 
							onConfirmation = {() => handleFullAmountStorne()}
							onClose = {() => handleClose()}
			/>
			<div style={{minHeight:'100vh'}} {...handlers} ref={refPassthrough}>
			<Header pageNumber={4} prevPage={prevPage}/>
	 		<div className="details-body">
				{articles!==null&&
				<div>
			 	<div className="articles-details">
				 	<div className="details-title">Artikli transakcije</div>
				 	<div className="details-table">
					 	<Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                            <TableHead style={{zIndex:popup?'-1':'1'}} >
                                <TableRow>
                                    <TableCell className={classes.nameHead} 
												style={{width:'20%'}} 
												component="td" 
												scope="row"
									>Proizvod</TableCell>
                                    <TableCell className={classes.priceHead}
												style={{width:'20%'}}  
												component="td" 
												scope="row" 
												align="center"
									>Cijena</TableCell>
                                    <TableCell className={classes.quantityHead}
												style={{width:'15%'}} 
												component="td" 
												scope="row" 
												align="right"
									>Količina</TableCell>
									{!isMobile&&<TableCell style={{width:'20%'}} component="td" scope="row"/>}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(articles!==null)?
								articles.map((ele, id) =>
                                    <TableRow key={id}>
                                        <TableCell className={classes.nameBody} 
                                                    component="td" 
                                                    scope="row" 
                                                    align="left"
                                        ><div style={{wordWrap:'break-word'}}>{ele.item.name}</div></TableCell>
                                        <TableCell className={classes.priceBody}   
													component="td" 
													scope="row" 
													align="center"
										>{ele.item.price.toFixed(2)} EUR</TableCell>
                                        <TableCell className={classes.quantityBody} 
													component="td" 
													scope="row" 
													align="right"
										>{ele.quantity} kom</TableCell>
										{!isMobile&&<TableCell component="td" scope="row"/>}
                                    </TableRow>):null
                                     }
                            </TableBody>
                        </Table>
						<div className="articles-sum" style={{marginRight:!isMobile?'26%':'0%'}}><span className="article-sum-txt">Ukupno: </span><span className="article-sum-subtxt">{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</span></div> 
					</div>
			 	</div>
				<Divider style={{padding:'0.5rem', marginTop:'0.3rem'}}/>
				</div>}
			 	<div className="trans-details">
				 	<div className="details-title">Detalji transakcije</div>
				 	<ul className="trans-details-list">
	 					<li><span className="trans-details-list-title">id računa</span><span className="trans-details-list-value">{item.keksId}</span></li>
						 <Divider />
						<li><span className="trans-details-list-title">Datum i vrijeme</span><span className="trans-details-list-value">{moment(item.epochtime).format("DD.MM.YYYY HH:mm")}</span></li> 
						<Divider />
						<li><span className="trans-details-list-title">Iznos transakcije</span><span className="trans-details-list-value">{(item.epochtime/1000>1672531200?<div>{item.amount.toFixed(2)} EUR</div>:<div>{(item.amount/7.5435).toFixed(2)} EUR</div>)}</span></li>
						{item.amountVoided!==0&&<Divider />}
						{item.amountVoided!==0&&<li><span className="trans-details-list-title">Iznos storna</span><span className="trans-details-list-value" style={{color:'red'}}>{(item.epochtime/1000>1672531200?<div>{item?.amountVoided.toFixed(2)} EUR</div>:<div>{(item?.amountVoided/7.5435).toFixed(2)} EUR</div>)}</span></li>}
					</ul>
			 	</div>
			 	<Divider style={{padding:'0.5rem'}}/>
				{item.amountVoided!==item.amount&&
				<div className="details-storne-btn">
					<Button size="large" 
                 		variant="contained"
						disabled={item.amountVoided!==0}
                 		style={{ width:!isMobile?'25rem':'90%',
                             	color:"#fff", 
                             	fontWeight: 'bold', 
                             	backgroundColor: item.amountVoided!==0?'secondary':COLORS.blue, 
                     		 	textTransform: 'none',
							 	margin:'1rem',
								"&:hover": {
									backgroundColor: item.amountVoided!==0?'secondary':COLORS.blue,
							    } 
                       			}}
						onClick = {()=>setPopup(true)}
			 		>STORNO TRANSAKCIJE</Button>
				</div>}
				{item.amountVoided!==item.amount&&
				<div className="details-storne-btn">
					<Button size="large" 
                 		variant="contained"
                 		style={{ width:!isMobile?'25rem':'90%',
                             	color:item.amountVoided!==0?"#fff":COLORS.blue, 
                             	fontWeight:'bold', 
                             	backgroundColor:item.amountVoided!==0?COLORS.blue:"#fff" ,
								border:'2px solid #2F2F5B', 
                     		 	textTransform:'none',
								textDecoration:'none',
							 	margin:'1rem',
								marginTop:'0rem',
								"&:hover": {
									backgroundColor:item.amountVoided!==0?COLORS.blue:"#fff"
							  	} 
                       			}}
						component={Link}
						to={`/kekspos/${params.tid}/djelomicno-storno/${params.keks_id}`}
						onClick = {() => partialStorne(item)}
			 		>DJELOMIČNI STORNO</Button>
				</div>}
    		</div>
			</div>
		</div>
  	)
	}else if(isConfirm&&!isLoading){
		return(
			<Confirmation cid={cid} 
						processed={true} 
						pageNumber={4} 
						prevPage={prevPage} 
						onBackToStorne={() => setIsConfirm(false)}  />
		)
	}else if(!isConfirm&&isLoading){
		return(
			<Loading />
		)
	}
}

export default DetailsList
